import { generateGuid, curlyTemplate } from '@bingads-webui-universal/primitive-utilities';
import WindowAbstraction from '@bingads-webui-clientcenter/window-interface';
import AddIframe from '@bingads-webui-clientcenter/add-iframe';

const iframeId = 'GreenIdIframe';

// eslint-disable-next-line func-names
export default function (greenIdUrl: string) {
  const urlTemplate = curlyTemplate(greenIdUrl);
  const greenIdIframe = WindowAbstraction.document.getElementById(iframeId);
  let guid = greenIdIframe && greenIdIframe.getAttribute('guid');

  if (!greenIdIframe || !guid) {
    guid = generateGuid();
    AddIframe(urlTemplate({ guid }), (iframe) => {
      // eslint-disable-next-line no-param-reassign
      iframe.id = iframeId;
      iframe.setAttribute('guid', guid);
    });
  }
  return guid;
}
